import React from "react"
import tw from "twin.macro"
import { Link } from "gatsby"

import { withNavigationFooter } from "./withNavigationFooter"
// import { StyledH2, StyledP } from "../../Styled/Text"
import FooterSocialLinks from "../../Footer/FooterSocialLinks"

// const Wrapper = tw.div`w-full md:w-2/3`
const Wrapper = tw.div`w-full md:w-3/4`
const Desktop = tw.div`hidden w-full md:flex flex-wrap pb-1-6`
const Mobile = tw.div`block flex flex-wrap md:hidden`
const DesktopList = tw.div`w-1/4 block pb-1-6`
const MobileList = tw.div`pb-3-2 w-1/2`
const Title = tw.div`block`
const Menu = tw.div``
// const Title = tw(StyledH2)`block`
const ListItem = tw(Link)`block leading-1.6 hover:text-dark transition-all duration-fast text-14 md:text-18`

const NavigationFooter = withNavigationFooter(({ items }) => (
  <Wrapper>
    <Desktop>
      {items?.map(
        (item, index) =>
          index !== items.length - 1 && (
            <DesktopList key={index}>
              <Title className="footer_heading" style={{ marginBottom: "11px" }}>
                {item?.title}
              </Title>
              {item?.items?.map((listItem, index) => (
                <ListItem key={index} to={listItem.link || "/"}>
                  {/* <StyledP>{listItem.title}</StyledP> */}
                  <Menu className="footer_menu">{listItem.title}</Menu>
                </ListItem>
              ))}
              {item?.includeSocial ? <FooterSocialLinks /> : null}
            </DesktopList>
          )
      )}
    </Desktop>
    <Mobile>
      {items?.map(
        (item, index) =>
          index !== items.length - 1 && (
            <MobileList key={index}>
              <Title className="footer_heading" style={{ marginBottom: "10px" }}>
                {item?.title}
              </Title>
              {item?.items?.map((listItem, index) => (
                <ListItem key={index} to={listItem.link || "/"}>
                  {/* {listItem.title} */}
                  <Menu className="footer_menu">{listItem.title}</Menu>
                </ListItem>
              ))}
              {item?.includeSocial ? <FooterSocialLinks /> : null}
            </MobileList>
          )
      )}
    </Mobile>
  </Wrapper>
))

export default NavigationFooter
